import FeaturesMap from '@apps-common/ui-maps/FeaturesMap';
import GeojsonLayer from '@apps-common/ui-maps/GeojsonLayer';
import React from 'react';
import {object} from 'prop-types';

export const CompareMap = ({geometry, candidate}) => {
  return (
    <FeaturesMap
      features={[
        {
          type: 'Feature',
          geometry,
        },
      ]}
      allowInteractions={false}
      showMapControls={false}
      animationDuration={0}
      featuresStyle="defaultSecondary"
    >
      <GeojsonLayer
        features={[
          {
            type: 'Feature',
            geometry: candidate.geometry,
          },
        ]}
      />
    </FeaturesMap>
  );
};

CompareMap.propTypes = {
  candidate: object.isRequired,
  geometry: object.isRequired,
};
